<template>
    <div class="spacer" />
</template>
<script>

    export default {
        name: 'Spacer',
    };
</script>